import { RESTError } from "../core/RESTError";

/**
 * An error that occurs when a software should be downloaded,
 * but no transport was found for the corresponding path.
 *
 * So e.g. for DM 2401 00 no software was provided.
 */
export class PathNotFoundError extends RESTError {}
